module.exports = __webpack_public_path__ + "static/media/Sleekflow_logo_2x.f7d99235.svg";